import { api } from '@shared/api/axios-instance';

export interface LoginVariables {
  email: string;
  password: string;
  captcha_token: string;
}

interface LoginResponse {
  access_token: string;
  refresh_token: string;
}

export const login = async ({ email, password, captcha_token }: LoginVariables): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>('/api/auth/login', {
    email,
    password,
    captcha_token,
  });
  return response.data;
};
